import { Box, Dialog, DialogContent, DialogTitle, Grid2, Paper } from '@mui/material';
import React, { Suspense, useEffect, useMemo } from 'react';
import Tabla from '../../../../components/ui/materialui/tabla';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { useColumns } from '../utils/columnsListado';
import useArchivoMinvu from '../hooks/useArchivoMinvu';
import ModalListArchivo from './modalListArchivo';

interface IProps {
    show: boolean;
    onHide: () => void;
    tipoArchivo: string;
}

const ModalListSeguros: React.FC<IProps> = ({ show, onHide, tipoArchivo }) => {

    const { dataListSeguro, getDataListSeguro } = useArchivoMinvu();

    const renderizar = () => {
        getDataListSeguro();
    }

    const { COLUMNS } = useColumns(renderizar);
    //eslint-disable-next-line
    const columns = useMemo(() => COLUMNS, []);

    useEffect(() => {
        if (!show) return;

        getDataListSeguro();
        // eslint-disable-next-line
    }, [tipoArchivo, show]);

    return (
        <Dialog
            open={show}
            onClose={onHide}
            maxWidth="xl"
        >
            <DialogTitle>
                Listado MINVU
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <Tabla
                                columns={columns}
                                data={dataListSeguro}
                            />
                            <Grid2 container justifyContent="flex-end" mt={2}>
                                <MButton variant="contained" onClick={onHide} >
                                    Volver
                                </MButton>
                            </Grid2>
                        </Suspense>
                    </Paper>
                </Box>
            </DialogContent>
       
        </Dialog >
    );
};

export default ModalListSeguros;